import type {
  DocumentData,
  DocumentReference,
  PartialWithFieldValue,
} from 'firebase/firestore'
import {
  collection,
  doc,
  serverTimestamp,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import type { FirestoreRoomStateInspector } from './schema'
import { schema } from './schema'
import { setDocWithError } from '../../firestore-mobx/fetch'
import { RoomStateInspector } from '../../models/RoomStateInspector'

export * from './schema'

const converter: FirestoreDataConverter<FirestoreRoomStateInspector> = {
  toFirestore: (data: PartialWithFieldValue<FirestoreRoomStateInspector>) => {
    return data
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

const getDocRef = (
  firestore: Firestore,
  params: {
    roomId: string
  }
): DocumentReference<FirestoreRoomStateInspector, DocumentData> => {
  const roomStateRef = doc(collection(firestore, 'room_state'), params.roomId)
  const feedbackCollectionRef = collection(
    roomStateRef,
    'inspector'
  ).withConverter(converter)

  return doc(feedbackCollectionRef, params.roomId)
}

export const createRoomStateInspectorRequest = async (
  firestore: Firestore,
  roomId: string
) => {
  const ref = getDocRef(firestore, { roomId })

  await setDocWithError(
    ref,
    {
      state: 'requested',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    {
      errorName: 'CreateRoomStateInspectorError',
    }
  )
}

export const getRoomStateInspectorData = (
  repository: FirebaseRepository,
  params: {
    roomId: string
  }
) => {
  const ref = getDocRef(repository.firestore, params)

  return modelItemStream(repository, ref, RoomStateInspector)
}
